import { type FunctionComponent } from 'react';
import { NON_BREAKING_SPACE } from '../../../constants/general';
import { generateCloudinaryUrl } from '../../../helpers/cloudinary-helper/cloudinary-helper';
import { type PromoBannerVariationOptions } from '../../../types/promo-banner.types';
import { StyledButton } from '../../buttons';
import { CloudinaryImage } from '../../images/cloudinary-image/cloudinary-image.component';
import { BannerImage } from '../banner-image/banner-image.component';
import { DoorMarker } from '../promo-helpers/door-marker.component';
import { defaultCouponExpirationString } from '../promo-helpers/promo-banner.helpers';

export const PromoBannerD: FunctionComponent<PromoBannerVariationOptions> = ({
	headline,
	subHeading,
	couponCode,
	expirationDate,
	action,
	image,
	imageShade,
	imageOverlay
}) => {
	const backgroundUrl = generateCloudinaryUrl(image.id, {
		width: 600,
		height: undefined,
		gravity: 'custom',
		zoom: '0.9',
		crop: 'thumb'
	});
	const actionName = action?.name || '';

	return (
		<div className={`ba b--theme-grey-light`}>
			<div className="flex-ns pa1">
				<div className="b--dashed b--theme-primary ba bw2 pa2 pa3-ns w-60-m w-40-l">
					<div className="db dn-ns">
						{couponCode ? (
							<div className="pa2">
								<DoorMarker />
								COUPON: <span className="theme-emphasis">{couponCode}</span>
							</div>
						) : (
							''
						)}
					</div>
					<div className="b f3-ns mt2 theme-primary">{headline}</div>
					<div className="f5-ns f6 mt2 theme-grey-darker">{subHeading}</div>
					<div className="dn db-ns">
						<div className="flex items-center mt3-ns">
							{action && <div className="dn db-ns mr3">{actionName && <StyledButton>{actionName}</StyledButton>}</div>}
							<div className={`f7 nowrap theme-grey`}>{defaultCouponExpirationString(couponCode, expirationDate)}</div>
						</div>
					</div>
				</div>
				<BannerImage
					className="flex min-h4 ml1-ns mt1 mt0-ns relative w-40-m w-60-l"
					backgroundUrl={backgroundUrl}
					imageShade={imageShade}>
					<div className="w-50 w-100-ns">
						{imageOverlay && (
							<CloudinaryImage
								publicID={imageOverlay.id}
								description="promo"
								className="absolute bottom-0 left-0 left-auto-ns max-h-100 mw-50 pa3 right-0-ns top-0 top-auto-ns"
								options={{
									width: 200,
									height: undefined,
									crop: 'lfill',
									gravity: 'custom',
									preserveTransparency: true
								}}
								useDimensions={false}
							/>
						)}
					</div>
					<div className="dn-ns w-50">
						<div className="f7 nowrap-ns pr3 pt2 theme-white tr">
							{couponCode ? <span className="dn di-ns">COUPON: {couponCode} </span> : ''}
							{expirationDate ? `Exp.${NON_BREAKING_SPACE}${expirationDate}` : ''}
						</div>
						<div className="absolute bottom-0 pa2 right-0 theme-white">{actionName}</div>
					</div>
				</BannerImage>
			</div>
		</div>
	);
};
